import { IAddlPredDto } from './addl-pred.model'

export interface ICompanyDto {
  companyId: number
  ticker: string
  name: string
  sector: string
  addlPred?: IAddlPredDto
}

export interface ICompanyPriceDto {
  id: number
  companyId: number
  isDeleted: string
  asofDate: string
  version: number
  lastUpdateTime: string
  insertTime: string
  date: string
  open: number
  high: number
  low: number
  close: number
  volume: number
  dividends: number
  closeunadj: number
  company?: ICompanyDto
}

export enum ECompanyInfoRoute {
  EARN = 'main',
  STOCK_PREDICTIONS = 'scenarios',
  HISTORICAL_DATA = 'history',
  COMPARABLE_COMPANIES = 'comps',
  EDGAR_REPORT = 'edgar-report',
}
